import { z } from 'zod'

export const capacityDeltaFormSchema = z.object({
  changeCapacity: z
    .number({
      message: '숫자만 입력할 수 있어요.',
    })
    .min(1, { message: '케파는 1 이상 입력해 주세요.' })
    .max(99999999, { message: '최대 99,999,999까지 입력할 수 있어요.' }),
})

export type CapacityDeltaFormSchema = z.infer<typeof capacityDeltaFormSchema>
